// App.js

import React from "react";
import { Routes, Route } from "react-router-dom";
import ShopifyPage from "./Pages/Shopify"; // Import the Shopify page component
import PartnerWithUs from "./Pages/Magic";
import CreativePartnerLandingPage from "./Pages/PartnerLandingPage";
import AuthPage from "./Pages/AuthPage"; // Import the Auth page component

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<CreativePartnerLandingPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/magic" element={<PartnerWithUs />} />
        <Route path="/shopify" element={<ShopifyPage />} />
      </Routes>
    </div>
  );
}

export default App;
